import { getLocalValue, saveLocalValue } from "../utilities/localStore/calls";

export interface iPreference {
    interface: {
        MailboxMenuVisible: boolean;
        MyEnquiriesQueueStatusVisible: boolean;
        LeftPane: number;
        RightPane: number;
        SideBarExpanded: boolean;
        ShowViewOnlyQueues?: boolean;
    };
    pinnedDashboardIds: Array<number>;
    grids: {
        myEnquiries: Array<iGridColumn>;
        myEnquiriesCompleted: Array<iGridColumn>;
        mailbox: Array<iGridColumn>;
        search: Array<iGridColumn>;
        myTeam: Array<iGridColumn>;
        myTeamCompleted: Array<iGridColumn>;
    };
}
export interface iGridColumn {
    title: string;
    columnWidth: string;
    visible: boolean;
}
export const getPreference = (): iPreference => {
    let preference = getLocalValue<iPreference>("preference");
    if (!preference) {
        preference = {
            interface: {
                MailboxMenuVisible: true,
                MyEnquiriesQueueStatusVisible: false,
                LeftPane: 50,
                RightPane: 50,
                SideBarExpanded: true,
            },
            pinnedDashboardIds: [],
            grids: defaultGridValues(),
        };
        savePrefence(preference);
        return preference;
    }

    if (preference.pinnedDashboardIds == undefined) {
        preference.pinnedDashboardIds = [];
        savePrefence(preference);
    }
    if (preference.grids == undefined) {
        preference.grids = defaultGridValues();
        savePrefence(preference);
    } else {
        if (preference.grids.myEnquiries[0].visible == undefined) {
            // if there is no visible prop in the local storage then clear it
            preference.grids = defaultGridValues();
            savePrefence(preference);
        }
        if (preference.grids.myTeam == undefined) {
            preference.grids.myTeam = defaultGridValues().myTeam;
            preference.grids.myTeamCompleted = defaultGridValues().myTeamCompleted;
            savePrefence(preference);
        }
    }
    if (preference.interface.SideBarExpanded == undefined) {
        preference.interface.SideBarExpanded = true;
        savePrefence(preference);
    }

    return preference;
};

export const savePrefence = (data: iPreference) => {
    saveLocalValue("preference", data);
};

export const defaultGridValues = () => {
    return {
        myEnquiries: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
        myEnquiriesCompleted: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "dateCompleted", columnWidth: "95px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
        mailbox: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "owners", columnWidth: "130px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
        search: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "owners", columnWidth: "130px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "dateCompleted", columnWidth: "95px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
        myTeam: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "owners", columnWidth: "130px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "dateCompleted", columnWidth: "95px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
        myTeamCompleted: [
            { title: "verticalSPacer", columnWidth: "20px", visible: true },
            { title: "priority", columnWidth: "20px", visible: true },
            { title: "hasAlarm", columnWidth: "18px", visible: true },
            { title: "hasUnworkedAttachments", columnWidth: "20px", visible: true },
            { title: "enquiryReference", columnWidth: "115px", visible: true },
            { title: "owners", columnWidth: "130px", visible: true },
            { title: "enquirerName", columnWidth: "120px", visible: true },
            { title: "dateReceived", columnWidth: "95px", visible: true },
            { title: "activeSlaCycle.timeout", columnWidth: "95px", visible: true },
            { title: "status", columnWidth: "150px", visible: true },
            { title: "subject", columnWidth: "220px", visible: true },
            { title: "dateCompleted", columnWidth: "95px", visible: true },
            { title: "workItems", columnWidth: "40px", visible: true },
        ],
    };
};
